import React, { Component } from 'react';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { OUTPUT_TTL } from '../../constants/Pac';

@inject('batchStore')
@observer
class Vibrator extends Component {

  render() {
    const { device, batchStore } = this.props;
    const active = batchStore.isOutputOn(device.switchOnePNo) ? 'active' : '';
    const btnClass = active ? 'active btn-batch-red' : 'btn-batch-green';
    const duration = active ? 0 : OUTPUT_TTL;

    return (
      <div id={`device-${device.id}`} className={`${active} device-gui device-gui--vibrator device-icon-${device.icon}`}>
        {device.description && (
          <div className="device-label device-icon">
            <div className="device-type" title={`#${device.id}`}>{device.description}</div>
          </div>
        )}
        <div className="device-icon body"/>
        <div className="device-icon wave"/>
        <div className="device-icon weight"/>
        <div className="device-gui__row">
          <NormalButton className={`btn-batch ${btnClass}`}
            port={device.switchOnePNo}
            duration={duration}>
            <i className="fa fa-power-off" />
          </NormalButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Vibrator);
